function formatSecond(seconds) {
    if (seconds) {
        if (seconds / 60 < 1) {
            return (financial(seconds - Math.floor(seconds / 60) * 60)) + "秒"
        } else {
            return Math.floor(seconds / 60) + "分 " + (financial(seconds - Math.floor(seconds / 60) * 60)) + "秒"
        }
    } else {
        return ""
    }
}

function formatSecondWithoutUnit(seconds) {
    if (seconds) {
        if (seconds / 60 < 1) {
            return "00:" + zeroFill(seconds - Math.floor(seconds / 60) * 60, 2)
        } else {
            return zeroFill(Math.floor(seconds / 60), 2) + ":" + zeroFill(seconds - Math.floor(seconds / 60) * 60, 2)
        }
    } else {
        return "00:00"
    }
}

function financial(x) {
    return Number.parseFloat(x).toFixed(2);
}

function zeroFill( number, width ) {
  width -= number.toString().length;

  if ( width > 0 ) {
    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
  }

  return number + ""; // always return a string
}

export {
    formatSecond,
    formatSecondWithoutUnit
}
